<style scoped>
.visit-stats {
  width: calc(100%);
  margin: 0 auto;
  font-family: 'Arial', sans-serif;
}

h2 {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
}

.chart-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
}

.chart {
  /*width: calc(100% - 160px);*/
  width: 100%;
  min-height: 300px;
  height: 100%;
}
.legend-container{
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 0px;
}
.legend {
  display: flex;
  justify-content: center;
  align-items: center;
  /*margin-bottom: 20px;*/
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
}

.legend-item:not(:last-child){
  margin-right: 20px;
}

.legend-color {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: inline-block;
}

.legend-label {
  color: #555;
}

</style>
<style>
.visitor-echart-desc{
  font-size: 18px!important;
  padding: 20px!important;
}
</style>


<template>
  <div class="visit-stats">
    <div class="chart-container">
      <div ref="chartRef" class="chart" v-loading="loading"></div>
      <div class="legend-container">
        <div class="legend">
          <div class="legend-item">
            <span class="legend-color" style="background-color: #5470c6;"></span>
            <span class="legend-label">实际到访: {{ formData.actualVisit }}人</span>
          </div>
          <div class="legend-item">
            <span class="legend-color" style="background-color: #91cc75;"></span>
            <span class="legend-label">未到访: {{ formData.noVisit }}人</span>
          </div>
          <div class="legend-item">
            <span class="legend-color" style="background-color: #fac858;"></span>
            <span class="legend-label">预计到访: {{ expectedVisit }}人</span>
          </div>
        </div>
        <el-popover
            placement="top-start"
            width="200"
            popper-class="visitor-echart-desc"
            trigger="hover"
            :content="content">
          <i slot="reference" class="el-icon-info" style="cursor: pointer;font-size: 16px;margin-left: 12px;color:#b6b4b4;"></i>
        </el-popover>
      </div>

    </div>
  </div>
</template>


<script>
import * as echarts from 'echarts';
import {VisitorApplyApi} from '@/api/server/visitorApply';

export default {
  components: {},
  props: {
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,
      chartInstance: null,
      formData: {
        actualVisit: 1,
        noVisit: 2,
      }
    };
  },
  watch: {
    type: {
      handler() {
        this.initChart();
      }
    }
  },
  created() {

  },
  mounted() {
    this.initChart();
  },
  computed: {
    content() {
      switch (this.type){
        case 1:
          return "如访客记录中开始时间-结束时间包含今日，将统计至[预计到访]，确认到访后访客随行人数将统计至[实际到访]";
        case 2:
          return "如访客记录中开始时间-结束时间包含本周（周一至周天），将统计至[预计到访]，确认到访后访客随行人数将统计至[实际到访]";
        case 3:
          return "如访客记录中开始时间-结束时间包含本月 「本月1号至次月1号(不含)」，将统计至[预计到访]，确认到访后访客随行人数将统计至[实际到访]";
      }
    },
    expectedVisit() {
      return this.formData.actualVisit + this.formData.noVisit;
    }
  },
  methods: {
    async initChart() {
      this.loading = true;
      // 销毁之前的图表实例
      if (this.chartInstance) {
        this.chartInstance.dispose();
      }
      // 初始化图表
      this.chartInstance = echarts.init(this.$refs.chartRef);

      const response = await VisitorApplyApi.queryUmsVisitorEchartCount({type: this.type});
      this.formData = {actualVisit: 0, noVisit: 0};
      if(response.code == 200){
        this.formData = {actualVisit: response?.data?.actualVisit || 0, noVisit: response?.data?.noVisit || 0};
      }

      const data = [
        { value: this.formData.actualVisit, name: '实际到访', itemStyle: { color: '#5470c6' } },
        { value: this.formData.noVisit, name: '未到访', itemStyle: { color: '#91cc75' } },
      ];
      if(this.formData.actualVisit === 0 && this.formData.noVisit === 0){
        data.splice(0);
      }

      const option = {
        tooltip: {
          trigger: 'item'
        },
        series: [
          {
            type: 'pie',
            radius: ['80%', '100%'],
            center: ['50%', '70%'],
            itemStyle: {
              borderRadius: 5
            },
            // adjust the start and end angle
            startAngle: 180,
            endAngle: 360,
            data: data,
          }
        ]
      }
      this.chartInstance.setOption(option);
      // 响应式调整图表大小
      window.addEventListener('resize', this.handleResize());
      this.loading = false;
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    }
  }
};
</script>